import React from 'react';
import styles from './ActivityLog.module.scss';
import { v4 as uuid } from 'uuid';
import { format } from 'date-fns';
import { UserDescription } from './components';
import { PropertyType } from '../../../common';

export const getRows = (logs: PropertyType[]): PropertyType[] =>
	logs.map((l, i) => [
		l.groupDate ? (
			<span key={uuid()} className={styles.GroupDate}>
				{format(new Date(l.groupDate), 'MMM dd, yyyy')}
			</span>
		) : null,
		<span key={uuid()}>{format(new Date(l.created_at), 'HH:mmaaa')}</span>,
		<span key={uuid()}>{<UserDescription log={l} order={i} />}</span>,
	]);
